import { useSelector } from 'react-redux';
import slidewords from './slideDictionary.js';
import Pills from '../pills/Pills.js';
import { languageSwitch } from '../../dictionary/translateFunctions.js';
import './slide.css';
import {useEffect, useState} from 'react'

const SlideB = () =>{
    const [index, setIndex] = useState(0);
    const lang = useSelector((state) => state.lang.lang);
    const dictionary = slidewords;
    const screen = window.screen.width;
    const device = screen > 500 ? 'desktop' : 'mobile';
    const images = {
        mobile:["/assets/galeria/about_1.jpg","/assets/galeria/about_2.jpg","/assets/galeria/about_3.jpg",],
        desktop:["/assets/galeria/about_1_L.jpg","/assets/galeria/about_2_L.jpg","/assets/galeria/about_3_L.jpg",],
    };

    useEffect(() => {
        const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % images[device].length);
        }, 6000);

        return () => clearInterval(interval);
    }, []);

    return(
        <div className='heroBanner-B'>
            <div className='heroBanner-B-img' style={{ backgroundImage: `url(${images[device][0]})`,transition: 'all 0.5s ease',opacity:index === 0? '100':'0'}}></div>
            <div className='heroBanner-B-img' style={{ backgroundImage: `url(${images[device][1]})`,transition: 'all 0.5s ease',opacity:index === 1? '100':'0' }}></div>
            <div className='heroBanner-B-img' style={{ backgroundImage: `url(${images[device][2]})`,transition: 'all 0.5s ease',opacity:index === 2? '100':'0' }}></div>
            <div className='heroBanner-B--personal'>
                {screen > 500 ? <h1 className='heroBanner-B--personal--name'>{dictionary.sBllt[lang]}</h1>:<h2 className='heroBanner-B--personal--name'>{dictionary.sBllt[lang]}</h2>}
            </div>
            <div className='heroBanner--presentation'>
                <p className='heroBanner-B--presentation--text'>{languageSwitch(dictionary.sBldd, lang)}</p>
                <div className='heroBanner-B--presentation--pills'>
                    {
                        dictionary.sBlds[lang].map((skill) => (
                        <Pills key={skill} type={'outlined'} color={'white'} text={skill} icon={'none'}></Pills>))
                    }
                </div>
            </div>
        </div>
    )
}

export default SlideB;